var _defs, _path, _g, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    "data-name": "Warstwa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.08 16.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-953.86 -514.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M953.86 514.25h16.08v16.08h-16.08z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-953.86 -514.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M954.36 522.3a7.54 7.54 0 107.54-7.55 7.55 7.55 0 00-7.54 7.55"
  })), /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1,.cls-6{fill:none}.cls-2{clip-path:url(#clip-path)}.cls-6{stroke:#00393f;stroke-width:.73px}\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M961.9 529.84a7.55 7.55 0 10-7.54-7.54 7.55 7.55 0 007.54 7.54",
    transform: "translate(-953.86 -514.25)",
    fill: "#00393f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#007260",
    d: "M3.54 4.59h9v12h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M5.04 6.95h6M5.04 9.24h6M5.04 11.54h6"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M961.9 529.84a7.55 7.55 0 10-7.54-7.54 7.55 7.55 0 007.54 7.54z",
    transform: "translate(-953.86 -514.25)",
    stroke: "#007260",
    fill: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.01f47d8d.svg";
export { ForwardRef as ReactComponent };